module.exports = __webpack_public_path__ + "img/box-skins-golden.287a0750.png";